import Marquee from "react-fast-marquee";

const phrases = [
  { text: "Founding 100", gold: false },
  { text: "$0 today", gold: true },
  { text: "No more guesswork", gold: false },
  { text: "Aventura FL", gold: false },
  { text: "250+ measurements", gold: false },
  { text: "See what your scale can't show", gold: true },
];

export const EditorialMarquee = () => (
  <div data-testid="editorial-marquee" className="border-y border-white/10 py-5 md:py-8 overflow-hidden">
    <Marquee speed={35} gradient={false}>
      {phrases.map((p, i) => (
        <span key={i} className="flex items-center">
          <span className={`mx-8 font-display uppercase text-3xl md:text-5xl whitespace-nowrap ${p.gold ? "text-gold" : i % 2 ? "text-volt" : "text-outline"}`}>
            {p.text}
          </span>
          <span className={`h-2 w-2 inline-block rotate-45 shrink-0 ${p.gold ? "bg-gold" : "bg-volt"}`} />
        </span>
      ))}
    </Marquee>
  </div>
);
